import * as React from "react";
import styled from "styled-components";
import {
	MenuListSortAscIcon,
	MenuListSortDescIcon,
	menuListSortIconColor,
} from "./icons/menu-list-icons";
import { MenuListSortDirection } from "../utils/sortLists";

const SortIconButton = styled.button`
	align-items: center;
	appearance: none;
	background: none;
	border: 0;
	cursor: pointer;
	display: flex;
	flex-shrink: 0;
	height: 16px;
	justify-content: center;
	padding: 0;
	width: 16px;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}

	&:not(:disabled):hover {
		opacity: 0.75;
	}
`;

interface Props {
	sortDirection: MenuListSortDirection;
	onSortDirectionChange: (direction: MenuListSortDirection) => void;
	disabled?: boolean;
	className?: string;
	compact?: boolean;
}

export const MenuSortDirectionButtons = ({
	sortDirection,
	onSortDirectionChange,
	disabled = false,
	className,
}: Props) => (
	<div className={className} style={{ display: "flex", gap: 16, flexShrink: 0, alignItems: "center" }}>
		<SortIconButton
			type="button"
			disabled={disabled}
			title="Sort A–Z"
			aria-label="Sort A–Z"
			aria-pressed={sortDirection === "asc"}
			onClick={() => onSortDirectionChange(sortDirection === "asc" ? null : "asc")}
		>
			<MenuListSortDescIcon color={menuListSortIconColor(sortDirection === "asc")} />
		</SortIconButton>
		<SortIconButton
			type="button"
			disabled={disabled}
			title="Sort Z–A"
			aria-label="Sort Z–A"
			aria-pressed={sortDirection === "desc"}
			onClick={() => onSortDirectionChange(sortDirection === "desc" ? null : "desc")}
		>
			<MenuListSortAscIcon color={menuListSortIconColor(sortDirection === "desc")} />
		</SortIconButton>
	</div>
);
